import React from "react";

export default function About() {
  return (
    <section id="about" className="bg-gray-900 text-white">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Hi, I'm Sam.
            <br className="hidden lg:inline-block" />I love to build amazing
            apps.
          </h1>
          <p className="mb-8 leading-relaxed text-base sm:text-lg md:text-xl text-left">
            I am a Senior Full-Stack Software Engineer specializing in building
            scalable, high-performance applications for businesses. With
            expertise in frontend and backend development, I handle everything
            from requirement gathering to deployment and maintenance. Leveraging
            my skills and experience, I enable companies to streamline
            operations, automate processes, and develop cutting-edge software
            solutions using the latest technologies in React, Next.js, Node.js,
            Java, Spring Boot, AI, and cloud computing (AWS, Azure, GCP). I am
            passionate about solving real-world challenges with innovative,
            efficient, and secure software solutions. Whether you need a custom
            web app, AI-powered automation, or enterprise software, I deliver
            high-quality results on time and within budget. 💡 Let’s build
            something great together! 🚀
          </p>

          <div className="flex justify-center flex-wrap gap-4">
            <a
              href="#contact"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg"
            >
              Work With Me
            </a>
            <a
              href="#projects"
              className="inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg"
            >
              See My Past Work
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center rounded w-full h-auto"
            alt="hero"
            src="./coding.svg"
          />
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/About.js